export const QUIZ_QUESTIONS = [
  {
    id: 1,
    question: "What type of golf course do you typically play on?",
    options: [
      { text: "Flat, easy terrain", value: "flat", icon: "1️⃣" },
      { text: "Some hills, moderate terrain", value: "moderate", icon: "2️⃣" },
      { text: "Very hilly, challenging slopes", value: "hilly", icon: "3️⃣" }
    ]
  },
  {
    id: 2,
    question: "How many holes do you usually play per round?",
    options: [
      { text: "9 holes or less", value: "9holes", icon: "⛳" },
      { text: "18 holes", value: "18holes", icon: "⛳⛳" },
      { text: "36+ holes (frequent player)", value: "36holes", icon: "🏌️" }
    ]
  },
  {
    id: 3,
    question: "What's most important to you?",
    options: [
      { text: "Maximum stability & comfort", value: "stability", icon: "🛡️" },
      { text: "Powerful performance & speed", value: "power", icon: "⚡" },
      { text: "Balance of features & portability", value: "balance", icon: "⚖️" }
    ]
  },
  {
    id: 4,
    question: "Do you need to transport your scooter frequently?",
    options: [
      { text: "Yes, in my car regularly", value: "portable", icon: "🚗" },
      { text: "Occasionally", value: "sometimes", icon: "🚙" },
      { text: "Rarely, mostly storage at course", value: "rarely", icon: "🏠" }
    ]
  },
  {
    id: 5,
    question: "What accessories interest you most?",
    options: [
      { text: "Premium seat for maximum comfort", value: "seat", icon: "💺" },
      { text: "Extra battery for extended range", value: "battery", icon: "🔋" },
      { text: "Full accessory package", value: "full", icon: "🎁" }
    ]
  }
];